module.exports = __webpack_public_path__ + "static/media/mommunity.f4c05a96.png";